import React from 'react';
import { Route, Redirect, IndexRedirect } from 'react-router';
import { startLoad } from './actions/loader';

import Head from './components/Head';
import Main from './components/Main';
import EmptyPage from './components/utils/EmptyPage';
import SelectLesson from './components/SelectLesson';
import SelectCourse from './components/SelectCourse';
import TinkercadLessonView from './components/TinkercadLessonView';
import NewAll from './components/NewAll';
import OldAll from './components/OldAll';

import Auth from './components/Auth';
import OldRegister from './components/Register';
import Register from './components/gui/register';
import ResetPassword from './components/ResetPassword';
import ConfirmEmail from './components/ConfirmEmail';
import ConfirmParent from './components/ConfirmParent';
import PaymentStatusPage from './components/shop/PaymentStatusPage';

import Special from './components/shop/offer/Special';

import PaymentHistory from './components/profile/PaymentHistory';
import LessonsHistory from './components/profile/LessonsHistory';
import Settings from './components/gui/Settings';
import EmployeeProfile from './components/profile/EmployeeProfile';
import Trial from './components/shop/Trial';

import Localizer from './components/Localizer';

import Promocode from '@components/shop/Promocode';

import SelectPlan from '@components/shop/SelectPlan';
import Tips from '@components/shop/Tips';
import Invitation from '@components/Invitation';
import { Projects, Project } from '@components/projects';

import ChatGPT from '@components/chatgpt';
import Onboarding from '@components/onboarding';

import Docker from '@components/Docker';

// Loading modules!
function loadRoute(cb) {
  return module => cb(null, module.default);
}

// throws an error in the console if the page wasn't able to load
function errorLoading(error) {
  console.error(error);
  throw new Error(`Dynamic page loading failed: ${error}`);
}

const innerRoutes = (
  <React.Fragment>
    <IndexRedirect to="i" />

    <Redirect from="plan" to="i/plan" />
    <Route path="onboarding/:id" component={Onboarding} />

    <Route
      path="h/:token"
      getComponent={(location, cb) => {
        import('./components/homework/HomeworkPublic')
          .then(loadRoute(cb))
          .catch(errorLoading);
      }}
    />

    <Route path="i" component={Main}>
      <IndexRedirect to="all" />

      <Route path="auth" component={Auth} />
      <Route path="old-register" component={OldRegister} />
      <Route path="register" component={Register} />
      <Route path="register/invite/:invite" component={Register} />
      <Route path="register/school/:school" component={OldRegister} />
      <Route path="register/flag/:flag" component={OldRegister} />
      <Route path="register/:token" component={OldRegister} />

      <Route path="reset" component={ResetPassword} />
      <Route path="reset/:token" component={ResetPassword} />

      <Route path="confirm" component={ConfirmEmail} />
      <Route path="confirm/:token" component={ConfirmEmail} />
      <Route path="confirm-parent/:token" component={ConfirmParent} />

      <Route path="invite" component={Invitation} />

      <Route path="payment-history" component={PaymentHistory} />
      <Route path="lessons-history" component={LessonsHistory} />

      <Route path="settings" component={Settings} />
      <Route path="profile" component={EmployeeProfile} />

      <Route path="chatgpt" component={ChatGPT} />

      <Route path="projects" component={Projects} />
      <Route path="projects/:id" component={Project} />

      <Route path="plan" component={SelectPlan} />

      <Route path="plan/:flag" component={SelectPlan} />

      <Route path="offer/special" component={Special} />
      <Route path="buy/trial" component={Trial} />
      <Route path="buy/promocode" component={Promocode} />
      <Route path="payment-status/:status" component={PaymentStatusPage} />

      <Route path="tips/:id" component={Tips} />

      <Route
        path="buy/:plan"
        getComponent={(location, cb) => {
          import('./components/shop/ShopCart')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="buy/:plan/:flag"
        getComponent={(location, cb) => {
          import('./components/shop/ShopCart')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      {/*  TODO: rework admin routes, remove query */}
      <Route
        path="gui/admin"
        getComponent={(location, cb) => {
          import('./components/gui/admin/editor/Admin.jsx')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/admin/translation"
        getComponent={(location, cb) => {
          import('./components/gui/admin/translation')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/admin/edit/:id"
        getComponent={(location, cb) => {
          import('./components/gui/admin/editor/Admin')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/users"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/users')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/invitations"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/Invitations')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/payments"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/PaymentStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/attempts"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/AttemptsStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/promocodes"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/PromocodesStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/subscriptions"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/SubscriptionStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/subs"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/UserSubscriptionStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/workinghours"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/WorkingHoursStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/new-lessons"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/LessonsStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/new-lessons/:id"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/LessonsStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/timetable"
        getComponent={(location, cb) => {
          import('./components/gui/admin/timetable')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/salary"
        getComponent={(location, cb) => {
          import('./components/gui/admin/salary')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/extrasalary"
        getComponent={(location, cb) => {
          import('./components/gui/admin/salary/ExtraSalary')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/mattermost"
        getComponent={(location, cb) => {
          import('./components/gui/admin/Mattermost')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route path="gui/docker" component={Docker} />

      <Route
        path="gui/playing"
        getComponent={(location, cb) => {
          import('./components/gui/admin/Playing')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/taskStats"
        getComponent={(location, cb) => {
          import('./components/gui/admin/TaskStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/chat"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/ChatStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/mails"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/MailStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/teachers"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/TeacherStats')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/links"
        getComponent={(location, cb) => {
          import('./components/gui/admin/Links')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/external-api-logs"
        getComponent={(location, cb) => {
          import('./components/gui/admin/stats/ExternalApiLogs')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route
        path="gui/homework/new"
        getComponent={(location, cb) => {
          import('./components/gui/homework/HomeworkForm')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />
      <Route
        path="gui/homework/:id/edit"
        getComponent={(location, cb) => {
          import('./components/gui/homework/HomeworkForm')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />
      <Route
        path="gui/homework/:id"
        getComponent={(location, cb) => {
          import('./components/gui/homework/HomeworkView')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />
      <Route
        path="gui/homework"
        getComponent={(location, cb) => {
          import('./components/gui/homework/HomeworkList')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Redirect from="gui" to="gui/snap" />

      <Route
        path="gui"
        getComponent={(location, cb) => {
          import('./components/gui/Gui')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      >
        <Route
          path="code(/:lesson)(/:task)"
          onEnter={() => startLoad('code', 'Грузим редактор Code')}
          getComponent={(location, cb) => {
            import('./components/gui/ace/Ace')
              .then(loadRoute(cb))
              .catch(errorLoading);
          }}
        />

        <Route
          path="scratch(/:lesson)(/:task)"
          onEnter={() => startLoad('scratch', 'Грузим редактор Scratch')}
          getComponent={(location, cb) => {
            import('./components/gui/scratch/Scratch')
              .then(loadRoute(cb))
              .catch(errorLoading);
          }}
        />
        <Route
          path="snap(/:lesson)(/:task)"
          onEnter={() => startLoad('snap', 'Грузим редактор Snap')}
          getComponent={(location, cb) => {
            import('./components/gui/snap/Snap')
              .then(loadRoute(cb))
              .catch(errorLoading);
          }}
        />
      </Route>

      <Route
        path="gui/plain/:lesson/:task"
        getComponent={(location, cb) => {
          import('./components/gui/Gui')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      {/* Добавление проектов в Demo   */}
      <Route
        path="gui/manage-project"
        getComponent={(location, cb) => {
          import('./components/gui/admin/addProject')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }}
      />

      <Route path="empty" component={EmptyPage} />

      <Route path="all-old" component={OldAll} />
      <Route path="all" component={NewAll} />
      <Route
        path="newall"
        onEnter={(nextState, replace) => replace('/i/all')}
      />
      <Route
        path="newall/:platform"
        onEnter={(nextState, replace) =>
          replace(`/i/${nextState.params.platform}`)
        }
      />

      <Route
        path="tinkercad/lesson/:lessonId"
        component={TinkercadLessonView}
      />

      <Route path=":platform(code|snap|plain|tinkercad)" exact component={NewAll} />

      <Route
        path=":platform(code|snap|tinkercad)/:course"
        exact
        component={SelectLesson}
      />

      <Route
        path=":platform(code|snap|tinkercad)/:course/:section"
        exact
        component={SelectLesson}
      />

      <Redirect from="*" to="/empty" />
    </Route>

    <Route path="404" component={EmptyPage} />
  </React.Fragment>
);

const localizedRoutes = locale => (
  <Route path={`/${locale}`} component={Localizer}>
    {innerRoutes}
  </Route>
);
const routes = (props = {}) => (
  <Route
    path="/"
    onChange={props.onRouteChange}
    onEnter={props.onInit}
    component={Head}
  >
    <Route path="" component={Localizer}>
      {innerRoutes}
    </Route>
    {localizedRoutes('en')}
    {localizedRoutes('ru')}

    <Redirect from="*" to="/404" />
  </Route>
);

export default routes;
